import * as model from './model.js';

import 'core-js/stable';
import 'regenerator-runtime/runtime';

const init = function () {
  const app = new model.App();
};

init();
